import React from "react"
import ProductOrderFieldFormRow from "./ProductOrderFieldFormRow"

const ProductOrderFieldsFormSection = ({ order, handleOrderedFieldValueChange }) => {
  const orderOrderedFields = order.ordered_product_order_fields
    .filter(orderedField => orderedField.visible)
    .filter(orderedField => !orderedField.product_order_field.has_pricing)

  return (
    <div className="NewOrderProductForm-product-options">
      {orderOrderedFields
        .map((orderedField, i) => (
          <ProductOrderFieldFormRow
            key={i}
            order={order}
            orderedField={orderedField}
            onChange={handleOrderedFieldValueChange.bind(null, order, orderedField)} />
        ))}

      {order.order_customer_participants.map(participant => {
        const customerOrderedFields = participant.ordered_product_order_fields
          .filter(orderedField => orderedField.visible)
          .filter(orderedField => !orderedField.product_order_field.has_pricing)

        return customerOrderedFields.length > 0 && [
          <h4>{participant.display_name}</h4>,
          ...customerOrderedFields
            .map((orderedField, i) => (
              <ProductOrderFieldFormRow
                key={i}
                order={order}
                orderedField={orderedField}
                onChange={handleOrderedFieldValueChange.bind(null, participant, orderedField)} />
            ))
        ];
      })}
    </div>
  )
}

export default ProductOrderFieldsFormSection


// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/ProductOrderFieldsFormSection.jsx